import Vue from '../vue/common/vue-common';
import WholesalerPage from '../vue/components/wholesaler/WholesalerPage';
import RenderNotifier from '../vue/components/common/RenderNotifier';

requestIdleCallback(
    () =>
        new Vue({
            el: '#wholesaler-page-vue',
            components: { WholesalerPage, RenderNotifier },
        })
);
